import { render, staticRenderFns } from "./PortTester.vue?vue&type=template&id=4b50e81e&"
import script from "./PortTester.vue?vue&type=script&lang=js&"
export * from "./PortTester.vue?vue&type=script&lang=js&"
import style0 from "./PortTester.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports